import {
  all,
  fork,
  put,
  takeLatest,
  takeEvery,
  call,
  select,
} from "redux-saga/effects";
import * as SensorGraphActions from "../actions";
import { NotificationManager } from "react-notifications";
import ApiConstants from "../api/ApiConstants";
import { get } from "src/helpers/HTTPRequest";
import { GenerateGraphData } from "src/helpers/GraphUtils";
import moment from "moment";
import _ from "underscore";
import TextConstants from "src/helpers/TextConstants";

function* fetchSensorGraphRawData({ payload }) {
  const { SensorId, bmId, settingsData } = payload;
  try {
    const url = `${ApiConstants.BASE_URL}${ApiConstants.BM_SENSORS.replace(
      "{:bmId}",
      bmId
    )}/${SensorId}`;
    const receivedData = yield call(get, url, {}, true);
    const currentSensor = receivedData;

    // raw data from sensors
    let fromDate = moment().local().format("YYYY-MM-DD");
    let toDate = moment().local().format("YYYY-MM-DD");
    if (settingsData && settingsData.fromDate && settingsData.toDate) {
      fromDate = settingsData.fromDate;
      toDate = settingsData.toDate;
    }

    const plotData = yield call(
      get,
      `${url}/data/raw?start-date=${fromDate}&end-date=${toDate}`
    );

    if (plotData.data.length === 0) {
      NotificationManager.error(TextConstants.NoDataFound, "", 5000);
    }

    // generate dummy graph data
    let sensorGraphData = GenerateGraphData(
      currentSensor,
      _.sortBy(plotData.data, "timestamp")
      // _.sortBy([], "timestamp") // just to check dummy plot data
    );

    let sensorList = yield select((state) => state.sensor.sensorDataCopy);
    if (sensorList.length === 0) {
      sensorList = yield call(
        get,
        `${ApiConstants.BASE_URL}${ApiConstants.BM_SENSORS.replace(
          "{:bmId}",
          bmId
        )}`
      );
    }
    const getCurrentSensorFromTheList = sensorList.find(
      (item) => item.sensorId === SensorId
    );

    yield put(
      SensorGraphActions.setSensorGraphDataSuccess({
        currentSensor: {
          ...currentSensor,
          ...(getCurrentSensorFromTheList && {
            currentTemp: getCurrentSensorFromTheList.currentTemp,
            lastInteractedAt: getCurrentSensorFromTheList.lastInteractedAt,
            lastUpdate: getCurrentSensorFromTheList.lastUpdate,
            status: getCurrentSensorFromTheList.status,
            isDF: getCurrentSensorFromTheList.isDF,
          }),
          // isWired field to display in sensor settings modal should be from sensorSettings, it is not from last data
          isWired: currentSensor.isWired,
        },
        sensorGraphData,
        settingsData,
      })
    );
  } catch (error) {
    console.log(error);
    yield put(SensorGraphActions.setSensorGraphDataFailure());
    NotificationManager.error(error.message, "", 5000);
  } finally {
    yield put(SensorGraphActions.setSensorGraphDataCleanState());
  }
}

function* getProductSettings() {
  try {
    const url = `${ApiConstants.BASE_URL}${ApiConstants.PRODUCT_SETTINGS}`;
    const receivedData = yield call(get, url);
    yield put(SensorGraphActions.getProductSettingsSuccess(receivedData));
  } catch (error) {
    yield put(SensorGraphActions.getProductSettingsFailure());
    NotificationManager.error(error.message, "", 5000);
  }
}

function* fetchSensorGraphDailyData({ payload }) {
  const { SensorId, bmId, settingsData } = payload;
  try {
    const url = `${ApiConstants.BASE_URL}${ApiConstants.BM_SENSORS.replace(
      "{:bmId}",
      bmId
    )}/${SensorId}`;

    // daily data from sensors
    let fromDate = moment().local().subtract(30, "days").format("YYYY-MM-DD");
    let toDate = moment().local().format("YYYY-MM-DD");
    if (settingsData && settingsData.fromDate && settingsData.toDate) {
      fromDate = settingsData.fromDate;
      toDate = settingsData.toDate;
    }

    const plotData = yield call(
      get,
      `${url}/data/daily?start-date=${fromDate}&end-date=${toDate}`
    );

    var sensorGraphData = [];

    for (var k = 0; k < plotData.data.length; k++) {
      var t1 = new Date(plotData.data[k].date);
      sensorGraphData.push([
        t1,
        plotData.data[k].avg_temp,
        plotData.data[k].min_temp,
        plotData.data[k].max_temp,
      ]);
    }

    if (sensorGraphData.length > 0) {
      yield put(
        SensorGraphActions.setSensorGraphDataDailySuccess({
          sensorGraphData,
          settingsData,
        })
      );
    } else {
      NotificationManager.error(TextConstants.NoDataFound, "", 5000);
      yield put(SensorGraphActions.setSensorGraphDataDailyFailure());
    }
  } catch (error) {
    yield put(SensorGraphActions.setSensorGraphDataDailyFailure());
    NotificationManager.error(error.message, "", 5000);
  } finally {
    yield put(SensorGraphActions.setSensorGraphDataDailyCleanState());
  }
}

function* letDownLoadGraphData({ payload }) {
  const { SensorId, bmId, settingsData } = payload;
  try {
    const url = `${ApiConstants.BASE_URL}${ApiConstants.BM_SENSORS.replace(
      "{:bmId}",
      bmId
    )}/${SensorId}`;

    // daily data from sensors
    let fromDate = moment().local().subtract(30, "days").format("YYYY-MM-DD");
    let toDate = moment().local().format("YYYY-MM-DD");
    if (settingsData && settingsData.fromDate && settingsData.toDate) {
      fromDate = settingsData.fromDate;
      toDate = settingsData.toDate;
    }

    const selectorePath =
      settingsData.displayType === "daily" ? "daily" : "raw";

    const plotData = yield call(
      get,
      `${url}/data/${selectorePath}?start-date=${fromDate}&end-date=${toDate}`
    );

    let currentSensor = yield select((state) => state.sensor.currentSensor);

    var sensorGraphData = [];

    if (selectorePath === "raw") {
      sensorGraphData = GenerateGraphData(
        currentSensor,
        _.sortBy(plotData.data, "timestamp")
      );
    } else {
      for (var k = 0; k < plotData.data.length; k++) {
        var t1 = new Date(plotData.data[k].date);
        sensorGraphData.push([
          t1,
          plotData.data[k].avg_temp,
          plotData.data[k].min_temp,
          plotData.data[k].max_temp,
        ]);
      }
    }

    if (sensorGraphData.length > 0) {
      yield put(
        SensorGraphActions.letDownloadRequestedDataSuccess(sensorGraphData)
      );
    } else {
      NotificationManager.error(TextConstants.NoDataFound, "", 5000);
      yield put(SensorGraphActions.letDownloadRequestedDataFailure());
    }
  } catch (error) {
    yield put(SensorGraphActions.letDownloadRequestedDataFailure());
    NotificationManager.error(error.message, "", 5000);
  } finally {
    yield put(SensorGraphActions.letDownloadRequestedDataCleanState());
  }
}

function* getSensorSetting({ payload }) {
  try {
    const { bmId, sensorId } = payload;
    const url = `${ApiConstants.BASE_URL}${ApiConstants.BM_SENSORS.replace(
      "{:bmId}",
      bmId
    )}/${sensorId}`;
    const sensorSettings = yield call(get, url);
    yield put(SensorGraphActions.getSensorSettingSuccess(sensorSettings));
  } catch (error) {
    yield put(SensorGraphActions.getSensorSettingFailure());
  } finally {
    yield put(SensorGraphActions.getSensorSettingCleanState());
  }
}

export function* watchSensorGraph() {
  yield takeEvery(
    SensorGraphActions.GET_SENSOR_GRAPH_DATA,
    fetchSensorGraphRawData
  );
  yield takeEvery(SensorGraphActions.GET_PRODUCT_SETTINGS, getProductSettings);
  yield takeEvery(
    SensorGraphActions.GET_SENSOR_GRAPH_DATA_DAILY,
    fetchSensorGraphDailyData
  );
  yield takeEvery(
    SensorGraphActions.LET_DOWNLOAD_REQUESTED_DATA,
    letDownLoadGraphData
  );
  yield takeLatest(SensorGraphActions.GET_SENSOR_SETTING, getSensorSetting);
}

export default function* sensorListSaga() {
  yield all([fork(watchSensorGraph)]);
}
